<template>
  <div v-if="maintenanceActiveFrom">
    <p
      v-if="maintenanceVariant === 'BANNER'"
      class="maintenance-banner"
    >
      {{ maintenanceMessage }}
    </p>
    <p
      v-if="maintenanceVariant === 'MAINTENANCE'"
      class="maintenance"
    >
      We have improved our Portal and scheduled delivery for
      <b> {{ maintenanceActiveFrom }} UTC</b> . Portal
      could go offline for a couple of minutes. Thanks for your patience.
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  mounted() {
    this.pollInterval = setInterval(() => {
      this.$store.dispatch('maintenance/fetchMaintenanceStatus')
    }, 10 * 60 * 1000)
  },
  created() {
    this.$store.dispatch('maintenance/fetchMaintenanceStatus')
  },
  destoyed() {
    clearInterval(this.pollInterval)
  },
  computed: {
    ...mapGetters({
      maintenanceActiveFrom: 'maintenance/maintenanceActiveFrom',
      maintenanceVariant: 'maintenance/maintenanceVariant',
      maintenanceMessage: 'maintenance/maintenanceMessage',
    }),
  },
}
</script>
<style scoped lang="scss">
  .maintenance {
    text-align: center;
    position: fixed;
    margin-bottom: 0px;
    width: 100%;
    z-index: 100;
    background-color: #fff;
  }
  .maintenance-banner {
    text-align: center;
    position: fixed;
    margin-bottom: 0px;
    width: 100%;
    z-index: 100;
    background-color: #fff;
    font-size: 17px;
    font-weight: bold;
  }
</style>
